// Import utilities
import {
	isEmpty,
	addParametersToURL
} from '@automator/utilities';

/**
 * Adds the UTM parameters to a given URL
 *
 * @param {String} url                 The URL
 * @param {Object} parameters          The parameters to add
 * @param {String} parameters.medium   The utm_medium
 * @param {String} parameters.campaign The utm_campaign
 * @param {String} parameters.content  The utm_content
 * @return {String}                     The URL with the parameters
 */
const addParametersUTM = ( url, { medium, campaign, content } ) => {
	// Define the parameters we're going to add
	const urlParameters = {};

	// Add the utm_source
	// eslint-disable-next-line camelcase
	urlParameters.utm_source = UncannyAutomator._site.automator.has_pro ? 'uncanny_automator_pro' : 'uncanny_automator';

	// Add the medium
	if ( ! isEmpty( medium ) ) {
		// eslint-disable-next-line camelcase
		urlParameters.utm_medium = medium;
	}

	// Add the campaign
	if ( ! isEmpty( campaign ) ) {
		// eslint-disable-next-line camelcase
		urlParameters.utm_campaign = campaign;
	}

	// Add the content
	if ( ! isEmpty( content ) ) {
		// eslint-disable-next-line camelcase
		urlParameters.utm_content = content;
	}

	// Check if we have to add the utm_r parameter
	if ( ! isEmpty( UncannyAutomator._site.automator.marketing_referer ) ) {
		// eslint-disable-next-line camelcase
		urlParameters.utm_r = UncannyAutomator._site.automator.marketing_referer;
	}

	// Add the parameters
	url = addParametersToURL( url, urlParameters );

	// Return the modified URL
	return url;
};

export default addParametersUTM;